import { gql } from '@apollo/client';

export const GetAgentHistory = gql`
    query getAgentHistory(
        $page: Int! = 1
        $size: Int! = 10
        $startDatetime: String = null
        $endDatetime: String = null
        $laterFirst: Boolean! = true
        $filterDate: Boolean! = false
        $dateAsc: Boolean! = true
        $filterTime: Boolean! = false
        $timeAsc: Boolean! = true
        $filterDuration: Boolean! = false
        $durationAsc: Boolean! = true
        $callerPhoneNumber: String = null
        $isDelete: Boolean! = false
        $agentId: Int = null
        $blockedOnly: Boolean! = false
    ) {
        getAgentHistory(
            page: $page
            size: $size
            startDatetime: $startDatetime
            endDatetime: $endDatetime
            laterFirst: $laterFirst
            filterDate: $filterDate
            dateAsc: $dateAsc
            filterTime: $filterTime
            timeAsc: $timeAsc
            filterDuration: $filterDuration
            durationAsc: $durationAsc
            callerPhoneNumber: $callerPhoneNumber
            isDelete: $isDelete
            agentId: $agentId
            blockedOnly: $blockedOnly
        ) {
            page
            pages
            calls {
                transcription
                called
                caller
                startTime
                summary
                callDuration
                recordingUri
                callSid
                contactInfo {
                    name
                    email
                }
            }
        }
    }
`;
